import { createAuthClient } from "better-auth/react";
import type { Auth } from "../../server/lib/auth";

export const authClient = createAuthClient<Auth>({
	baseURL: import.meta.env.VITE_BETTER_AUTH_URL || "http://localhost:4040",
	basePath: "/auth",
});
